<template>
  <div class="insert-parts-toolbar-root">
    <!-- Uses div strips instead of stacked v-app-bar so layout stays in normal flow on narrow viewports -->
    <div class="toolbar-strip bg-red-darken-3 pt-1">
      <v-row
        align="center"
        justify="center"
        no-gutters
        class="toolbar-search-row"
      >
        <!------------------------------------------TITLE------------------------------------------>
        <div
          class="text-h6 text-white ml-2 mr-6 py-2 hidden-md-and-down align-self-center"
        >
          {{ $t("parts.insert_parts.label") }}
        </div>
        <!----------------------------------------------------------------------------------------->
        <v-divider class="mx-2 hidden-md-and-down my-2" inset vertical />
        <!--------------------------------------SEARCH FIELD--------------------------------------->
        <v-col
          cols="12"
          sm="2"
          md="2"
          lg="2"
          class="mb-1 mb-lg-0 mb-md-0 toolbar-search-field px-2 "
        >
          <v-text-field
            v-model="search"
            density="compact"
            :label="$t('parts.insert_parts.search')"
            append-inner-icon="mdi-magnify"
            variant="solo"
            color="grey-darken-4"
            hide-details
            class="toolbar-field-on-red"
            @keyup.enter="searchMethod()"
            @click:append-inner="searchMethod()"
          />
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="3"
          lg="3"
          class="mb-1 mb-lg-0 mb-md-0 toolbar-search-field px-2"
        >
          <v-select
            v-model="searchType"
            density="compact"
            :items="searchTypes"
            item-title="label"
            item-value="value"
            color="grey-darken-4"
            variant="solo"
            hide-details
            class="toolbar-field-on-red"
          />
        </v-col>
        <!-----------------------------------SEARCH BY ID BUTTON----------------------------------->
        <!-- <v-btn
          dark
          small
          @click="searchById = !searchById"
        >
          <v-icon left>
            {{ searchById ? 'check_box': 'check_box_outline_blank' }}
          </v-icon>
          {{ $t('parts.insert_parts.id_only') }}
        </v-btn> -->
        <!----------------------------------------------------------------------------------------->
        <!-- <v-spacer class="hidden-md-and-down" /> -->
        <!-- md+: beside search fields (matching original hidden-sm-and-down gate for primary actions) -->
        <v-col
          cols="12"
          sm="2"
          md="4"
          lg="4"
          class="d-flex  ga-2 align-center hidden-sm-and-down"
        >
          <!-------------------------------------APPROVE BUTTON-------------------------------------->
          <v-btn
            v-if="approveBtn"
            :loading="loading"
            class="mr-1"
            color="grey-darken-4"
            variant="flat"
            @click="approveMethod"
          >
            <v-icon start> mdi-send-check-outline </v-icon>
            {{ $t("parts.insert_parts.approve") }}
          </v-btn>
          <!-----------------------------------INSERT EMPTY PARTS------------------------------------>
          <v-btn color="grey-darken-4" variant="flat" @click="insert" class="ml-2 ml-md-0 ml-lg-0">
            <v-icon start> mdi-file-document-plus-outline </v-icon>
            {{ $t("parts.insert_parts.empty_parts.insert_empty_parts") }}
          </v-btn>
        </v-col>
        <!----------------------------------------------------------------------------------------->
      </v-row>
    </div>

    <div class="toolbar-strip bg-red-darken-3 toolbar-actions-row">
      <div
        class="d-flex flex-wrap align-center justify-center toolbar-actions-inner ga-2 pa-2"
      >
        <!-- POPULATE FOR DEMO ACC -->
      <!--    <v-btn
          v-if="$store.getters.role == 'SuperAdmin'"
          class="mr-1 hidden-sm-and-down"
          variant="flat"
          @click="openPopulateWithCar"
        >
          <v-icon start> fas fa-plus </v-icon>
          Parts with Car
        </v-btn>
        <v-btn
          v-if="$store.getters.role == 'SuperAdmin'"
          class="mr-1 hidden-sm-and-down"
          variant="flat"
          @click="openPopulateWithoutCar"
        >
          <v-icon start> fas fa-plus </v-icon>
          Parts without Car
        </v-btn>
         -->
        <v-btn
          color="grey-darken-4"
          variant="flat"
          class="toolbar-action-btn"
          @click="exportToExcel"
        >
          {{ $t("parts.insert_parts.export") }}
          <v-icon end>mdi-file-excel-outline</v-icon>
        </v-btn>

        <!------------------- Mobile-first: avoids separate floating strip below app bars ----------->
        <v-btn
          v-if="approveBtn"
          :loading="loading"
          color="grey-darken-4"
          variant="flat"
          class="toolbar-action-btn hidden-md-and-up"
          @click="approveMethod"
        >
          <v-icon start> mdi-send-check-outline </v-icon>
          {{ $t("parts.insert_parts.approve") }}
        </v-btn>
        <v-btn
          color="grey-darken-4"
          variant="flat"
          class="toolbar-action-btn hidden-md-and-up text-none"
          @click="insert"
        >
          <v-icon start> mdi-file-document-plus-outline </v-icon>
          {{ $t("parts.insert_parts.empty_parts.insert_empty_parts") }}
        </v-btn>

        <!---------------------------------------QR SCANNER---------------------------------------->
        <v-btn
          color="grey-darken-4"
          variant="flat"
          class="toolbar-action-btn text-none"
          @click="openQrScanner"
        >
          <v-icon start> mdi-qrcode </v-icon>
          {{ $t("parts.insert_parts.qr_scanner.open_qr_scanner") }}
        </v-btn>
        <!-------------------------------------DELETE BUTTON--------------------------------------->
        <v-btn
          v-if="deleteBtn"
          :loading="loadingDelete"
          color="grey-darken-4"
          variant="flat"
          class="toolbar-action-btn"
          @click="deleteMethod"
        >
          <v-icon color="error" start> mdi-delete </v-icon>
          {{ $t("parts.insert_parts.delete") }}
        </v-btn>
        <!----------------------------------------------------------------------------------------->
      </div>
    </div>

    <!--------------------------------------------------------------------------------------------->
    <v-dialog v-model="populateWithoutCarModal" max-width="500">
      <v-card class="pa-3">
        <div class="ml-2 mb-2">
          Choose an institution to add parts that
          <strong>ARE NOT</strong> linked to a vehicle.
        </div>
        <div>
          <v-autocomplete
            v-model="institution"
            :items="displayedInstitutions"
            :loading="loadingInstitution"
            :label="$t('parts.advanced_search.institution')"
            persistent-hint
            item-title="title"
            item-value="_id"
            variant="solo"
            color="red-darken-1"
            class="ml-2 mr-2 pt-2"
            clearable
          />
        </div>
        <div class="col-12 text-end d-flex ml-auto">
          <v-btn
            :disabled="!institution"
            color="red-darken-3"
            class="white--text"
            @click="populateWithoutCar"
          >
            populate
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="populateWithCarModal" max-width="500">
      <v-card class="pa-3">
        <div class="ml-2 mb-2">
          Choose an institution to add parts that <strong>ARE</strong> linked to
          a vehicle.
        </div>
        <div>
          <v-autocomplete
            v-model="institution"
            :items="displayedInstitutions"
            :loading="loadingInstitution"
            :label="$t('parts.advanced_search.institution')"
            persistent-hint
            item-title="title"
            item-value="_id"
            variant="solo"
            color="red-darken-1"
            class="ml-2 mr-2 pt-2"
            clearable
          />
        </div>
        <div class="col-12 text-end d-flex ml-auto">
          <v-btn
            :disabled="!institution"
            color="red-darken-3"
            class="white--text"
            @click="populateWithCar"
          >
            populate
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
/* eslint-disable no-nested-ternary */
import moment from "moment";
import * as XLSX from "xlsx";
import postRequest from "../../api/postRequest";
import getRequest from "../../api/getRequest";
import { useDisplay } from "vuetify";

export default {
  components: {},
  props: ["items", "approve", "delete"], // eslint-disable-line vue/require-prop-types
  data: () => ({
    search: "",
    searchById: false,
    loading: false,
    loadingDelete: false,
    allowedInstitutions: [
      "686540c3a99dd439285ff063",
      "687de0e83d1b82a6724f89b0",
      // add more IDs here
    ],
    populateWithoutCarModal: false,
    populateWithCarModal: false,
    institution: "",
    displayedInstitutions: [],
    loadingInstitution: false,
    searchTypes: [
      { label: "Other", value: "regular" },
      { label: "ID", value: "id" },
      { label: "PRA", value: "pra" },
    ],
    searchType: "regular",
  }),
  computed: {
    approveBtn() {
      return this.$props.approve;
    },
    deleteBtn() {
      return this.$props.delete;
    },
    display() {
      return useDisplay();
    },
  },
  watch: {
    search(value) {
      if (value.length === 0) {
        this.$emit("clear-search");
      }
    },
    "$i18n.locale"() {
      this.getLocale();
    },
  },
  created() {
    this.getLocale();
    this.getInstitutions();
  },
  methods: {
    getLocale() {
      this.searchTypes[0].label = this.$t("parts.inventory.other");
      this.searchTypes[1].label = this.$t("parts.inventory.id");
      this.searchTypes[2].label = this.$t("parts.inventory.pra");
    },
    insert() {
      this.$emit("insert");
    },
    approveMethod() {
      this.$emit("approved");
    },
    deleteMethod() {
      this.$emit("deleted");
    },
    searchMethod() {
      if (this.search.length === 0) {
        //
      } else {
        this.$emit("search", {
          searchField: this.search,
          type: this.searchType,
        });
      }
    },
    openQrScanner() {
      this.$emit("scanner");
    },
    startLoading() {
      this.loading = true;
    },
    stopLoading() {
      this.loading = false;
    },
    startLoadingDelete() {
      this.loadingDelete = true;
    },
    stopLoadingDelete() {
      this.loadingDelete = false;
    },
    setId(id) {
      this.searchType = "id";
      this.search = id;
    },
    async exportToExcel() {
      const data = await this.exportData();

      // Create a worksheet
      const ws = XLSX.utils.json_to_sheet(data);

      // Create a workbook and append the worksheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "TemporaryParts");

      // Trigger download
      XLSX.writeFile(wb, "TemporaryParts.xlsx");
    },
    exportData() {
      const items = [];
      this.$props.items.forEach((item) => {
        const itemObject = {
          Status:
            item.status === 1
              ? "Available"
              : item.status === 2
                ? "Waiting Approval"
                : item.status === 3
                  ? "Review Needed"
                  : item.status === 4
                    ? "Refused"
                    : item.status === 5
                      ? "Approved"
                      : "",
          ID: item._id,
          Institution: item.institution_id.title,
          User: `${item.user_id.name} ${item.user_id.surname}`,
          Price: `${item.price} ${item.currency}`,
          Cost: item.cost ? `${item.cost} ${item.currency}` : "",
          "Shipment Name": item.shipment_id.name,
          "Warranty ID": item.warranty_id.title,
          Quality: item.quality.title,
          Location:
            item.shelf_id && item.shelf_data
              ? `${item.shelf_data.shelf.room_name}-${item.shelf_data.shelf.location_code}: ${
                  item.shelf_data.shelf.x
                }, ${item.shelf_data.shelf.y}`
              : "",
          "Date Created": moment(item.date_created).format("DD-MM-YYYY LT"),
        };
        items.push(itemObject);
      });
      return items;
    },
    openPopulateWithCar() {
      this.populateWithCarModal = true;
    },
    async populateWithCar() {
      this.loading = true;
      try {
        const response = await postRequest.object(
          `/demo/populate-temporary-parts-with-car?institution_id=${this.institution}`,
          null,
        );
        if (response) {
          this.populateWithCarModal = false;
          this.institution = "";
          this.$emit("clear-search");
          this.loading = false;
        }
      } catch {
        this.populateWithCarModal = false;
        this.institution = "";
        this.loading = false;
      }
    },
    openPopulateWithoutCar() {
      this.populateWithoutCarModal = true;
    },
    async populateWithoutCar() {
      this.loading = true;
      try {
        const response = await postRequest.object(
          `/demo/populate-temporary-parts-without-car?institution_id=${this.institution}`,
          null,
        );
        if (response) {
          this.populateWithoutCarModal = false;
          this.institution = "";
          this.$emit("clear-search");
          this.loading = false;
        }
      } catch {
        this.populateWithoutCarModal = false;
        this.institution = "";
        this.loading = false;
      }
    },
    getInstitutions() {
      this.loadingInstitution = true;
      getRequest("/institution/")
        .then((response) => {
          if (response && response.institutions) {
            this.displayedInstitutions = response.institutions;
          }
          this.loadingInstitution = false;
        })
        .catch(() => {
          this.loadingInstitution = false;
        });
    },
  },
};
</script>

<style scoped>
/* Normal document flow (no stacked app-bars) + wrap-friendly action row on small screens */
.insert-parts-toolbar-root .toolbar-strip {
  position: relative;
  z-index: 1;
  width: 100%;
}

.insert-parts-toolbar-root .toolbar-actions-inner .toolbar-action-btn {
  flex: 1 1 140px;
}

@media (min-width: 960px) {
  .insert-parts-toolbar-root .toolbar-actions-inner .toolbar-action-btn {
    flex: 0 1 auto;
  }
}
</style>
